import React from 'react';
import { IframeContent } from './IframeContent';

interface VideoContentProps {
  src: string;
  title: string;
}

export const VideoContent: React.FC<VideoContentProps> = ({ src, title }) => {
  return <IframeContent src={src} title={title} />;
};
